export default {
    GET_HOME_APARTMENTS: 'GET_HOME_APARTMENTS',
};



// WEBPACK FOOTER //
// ./src/containers/Home/HomeConstants.js